import React, { ReactElement, useEffect, useState } from 'react';
import { FieldGroupItem, FieldGroupVariant } from '@dexma/ui-components';

import i18n from 'asset/translation';
import FormFieldGroup from 'adapter/in/common/components/FieldGroup';
import { SelectorFieldDataImpl, SelectorOption, SelectorType } from 'adapter/in/common/form/types';
import { isSelectorFieldDataValid, useBaseSelectorContainer } from 'adapter/in/common/hooks/form/useBaseSelectorContainer';
import { useBaseDashboardsApiSelector } from 'adapter/in/common/hooks/form/useBaseDashboardsApiSelector';
import { FieldGroupContainerProps, onChangeFieldGroup } from 'adapter/in/common/form/FieldGroup';
import { dispatchFormChangesView } from 'adapter/in/common/context/formChanges';

export const ApiFieldGroupContainer = ({
    name,
    configType,
    dataDependsOn,
    label,
    affectsTo,
    footer,
}: FieldGroupContainerProps): ReactElement => {
    const [rules, setRules] = useState({});
    const { value, onChange, invalid, error, shouldLoad, dependantValues, register, trigger } = useBaseSelectorContainer(
        name,
        rules,
        undefined,
        dataDependsOn,
        affectsTo
    );
    const { setHasChange: setWidgetMenuHasChange } = dispatchFormChangesView();
    const { isLoading, maxSelectionLength, minSelectionLength, options } = useBaseDashboardsApiSelector<SelectorOption>(
        name,
        SelectorType.FIELD_GROUP,
        configType,
        0,
        value,
        shouldLoad,
        dependantValues,
        (updatedValue) => {
            onChange(updatedValue);
        }
    );

    useEffect(() => {
        const rulesToSet = {
            required: i18n.t('widgets.errorNotEmpty').toString(),
            validate: (v: SelectorFieldDataImpl) => isSelectorFieldDataValid(minSelectionLength, maxSelectionLength)(v),
        };
        setRules(rulesToSet);
        register(name, rulesToSet);
        trigger(name);
    }, [maxSelectionLength, minSelectionLength]);

    return (
        <FormFieldGroup
            name={name}
            isLoading={isLoading}
            label={label}
            options={options as FieldGroupItem[]}
            onChange={(data) => {
                setWidgetMenuHasChange(true);
                onChangeFieldGroup(onChange, configType)(data);
            }}
            value={value?.value}
            error={invalid && !!error && error.type !== 'loading'}
            variant={name === 'resolution-0' ? FieldGroupVariant.JOINED : FieldGroupVariant.SPLIT}
            footer={footer}
        />
    );
};

export default ApiFieldGroupContainer;
